/**
 * Public (no-login) event registration API. Talks to the Express backend, which validates
 * everything and writes with the Admin SDK — these visitors have no Firebase Auth account.
 */
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

const call = async (path, options) => {
  let res;
  try {
    res = await fetch(`${API_URL}${path}`, options);
  } catch {
    throw new Error('Could not reach the server. Please check your connection and try again.');
  }
  const body = await res.json().catch(() => ({}));
  if (!res.ok || body.success === false) {
    throw Object.assign(new Error(body.message || `Request failed (${res.status})`), {
      status: res.status, fieldErrors: body.errors || null,
    });
  }
  return body;
};

const post = (path, data) => call(path, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(data),
});

export const getRegistrationForm = (orgId, eventId) =>
  call(`/api/public/${encodeURIComponent(orgId)}/events/${encodeURIComponent(eventId)}/registration-form`);

export const submitRegistration = (orgId, eventId, payload) =>
  post(`/api/public/${encodeURIComponent(orgId)}/events/${encodeURIComponent(eventId)}/register`, payload);

export const getRegistrationResponse = (token) =>
  call(`/api/public/registration-response?token=${encodeURIComponent(token)}`);

export const submitRegistrationResponse = (token, action) =>
  post('/api/public/registration-response', { token, action });

export const fmtPublicDateTime = (iso) => {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('en-SG', {
    timeZone: 'Asia/Singapore', weekday: 'short', day: '2-digit', month: 'short',
    year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true,
  });
};
